var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Veículos",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "veiculo1",
      "label-for": "veiculo1",
      "label": "Caminhão"
    }
  }, [_c('VueSelect', {
    ref: "buscarVeiculo1",
    class: {
      hasErrors: _vm.veiculo1Error
    },
    attrs: {
      "filterable": false,
      "options": _vm.veiculos1
    },
    on: {
      "search": function search(_search, loading) {
        return _vm.onSearchVeiculos(_search, loading, 1);
      },
      "input": function input() {
        return _vm.veiculo1Error = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.caminhao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "caminhao", $$v);
      },
      expression: "form.caminhao"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Pesquise pela placa ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "veiculo2",
      "label-for": "veiculo2",
      "label": "1 Reboque"
    }
  }, [_c('VueSelect', {
    ref: "buscarVeiculo1",
    attrs: {
      "filterable": false,
      "options": _vm.veiculos2
    },
    on: {
      "search": function search(_search2, loading) {
        return _vm.onSearchVeiculos(_search2, loading, 2);
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.reboque1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reboque1", $$v);
      },
      expression: "form.reboque1"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Pesquise pela placa ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "veiculo3",
      "label-for": "veiculo3",
      "label": "2 Reboque"
    }
  }, [_c('VueSelect', {
    ref: "buscarVeiculo1",
    attrs: {
      "filterable": false,
      "options": _vm.veiculos3
    },
    on: {
      "search": function search(_search3, loading) {
        return _vm.onSearchVeiculos(_search3, loading, 3);
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.reboque2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reboque2", $$v);
      },
      expression: "form.reboque2"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Pesquise pela placa ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "veiculo4",
      "label-for": "veiculo4",
      "label": "3 Reboque"
    }
  }, [_c('VueSelect', {
    ref: "buscarVeiculo1",
    attrs: {
      "filterable": false,
      "options": _vm.veiculos4
    },
    on: {
      "search": function search(_search4, loading) {
        return _vm.onSearchVeiculos(_search4, loading, 4);
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.placa) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.reboque3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reboque3", $$v);
      },
      expression: "form.reboque3"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Pesquise pela placa ")])], 2)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };